import { ROUTE_PATH } from "common/constants/sm-constants";
import { FormMetaModel, SmBtnMetaModel } from "common/models/utility-models/meta-model";

export class FeedbackPreviewMetaModel extends FormMetaModel {
    constructor() {
        super('Feedback Preview', ROUTE_PATH.feedbackGrid, ROUTE_PATH.feedbackPreview, 3);
    }

    override initProperties(): any {
        const formInfo = super.initProperties();


        const buttons = {
            close: new SmBtnMetaModel('Close', '', true, false, true, true),
            isFormControl: false
        };


        return {
            formInfo,
            buttons
        }
    }
}